import jsPDF from "jspdf";
import "jspdf-autotable";
import dayjs from "dayjs";
import logo from "../Images/buillogo6.png";
import anotherLogo from "../Images/OGGS_Logo.png";

export const generateInvoice = (
  sellerdetails,
   calculatedVisibilityCharges,
  powerPackPrice,
  depositAmount,
  products,
  invoiceId,
  visibilityLevel,
  hsnCode,
  visibiliyCalculationDetails // Pass detailed breakdown

) => {

  console.log("Visibility Calculation Details in generateInvoice:", visibiliyCalculationDetails);

  const doc = new jsPDF();

  const formattedDate = dayjs().format("DD MMMM YYYY");
  const subTotal = calculatedVisibilityCharges  + powerPackPrice + depositAmount;
  const gstAmount = subTotal * 0.18;
  const totalAmount = subTotal + gstAmount;

  // Add border
  doc.setLineWidth(0.5);
  doc.rect(5, 5, 200, 287);

  // Header Section
  if (anotherLogo) {
    const anotherImage = new Image();
    anotherImage.src = anotherLogo;
    doc.addImage(anotherImage, "PNG", 10, 10, 40, 20);
  }
  if (logo) {
    const image = new Image();
    image.src = logo;
    doc.addImage(image, "PNG", 160, 10, 40, 20);
  }
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  doc.text("PERFORMA INVOICE", 105, 20, { align: "center" });
  doc.setFontSize(12);
  doc.text(`Date: ${formattedDate}`, 10, 40);
  doc.text(`Invoice ID: ${invoiceId}`, 10, 46);

  // Company and Seller Details in the Same Row
  const companyDetails = `OGCS private Limited, BuildPro OGCS
Navin Panvel,
Dist: Raigad, Pin Code: 410206
Contact: +91 9967610135
Email: support@buildproogcs.com
GST: 27AAEC01131F1ZW`;

  const sellerDetailsText = `Customer Details:
${sellerdetails.companyName}
${sellerdetails.address.street}
${sellerdetails.address.city}, ${sellerdetails.address.state}, ${sellerdetails.address.country} - ${sellerdetails.address.postalCode}
Contact: ${sellerdetails.mobile}
Email: ${sellerdetails.email}
PAN: ${sellerdetails.pan}
GST: ${sellerdetails.gstNumber}`;

  doc.setFontSize(10);
  doc.text(companyDetails, 10, 60);
  doc.text(sellerDetailsText, 110, 60);

  // Combined Table for Product Details and Charges Breakdown
  console.log("Product Data: ", products); // Log the product data
  const tableData = products.map((product) => [
    product.productName,
    `Rs ${product.productPrice}`,
    product.maxquantity,
    product.visibilityLevel,
    product.hsncode, // Corrected field name
    "-",
  ]);

  tableData.push(
    ["Visibility Charges", `Rs ${calculatedVisibilityCharges}`, "-", "-", "-", "-"],
    ["PowerPack Charges", `Rs ${powerPackPrice}`, "-", "-", "-", "-"],
    ["Deposit Charges", `Rs ${depositAmount}`, "-", "-", "-", "-"],
    ["Subtotal", `Rs ${subTotal.toFixed(2)}`, "-", "-", "-", "-"],
    ["GST (18%)", `Rs ${gstAmount.toFixed(2)}`, "-", "-", "-", "-"],
    ["Total Amount", `Rs ${totalAmount.toFixed(2)}`, "-", "-", "-", "-"]
  );

  const tableHeaders = [
    "Name",
    "Amount (Rs)",
    "Max Qty",
    "Visibility Level",
    "HSN Code", // Correct header name
    "Remarks",
  ];

  doc.autoTable({
    head: [tableHeaders],
    body: tableData,
    startY: 110,
    theme: "grid",
    margin: { left: 10 },
    styles: { fontSize: 10, cellPadding: 2 },
    headStyles: { fillColor: [41, 128, 185], textColor: [255, 255, 255] },
    footStyles: { fillColor: [41, 128, 185], textColor: [255, 255, 255] },
  });

  
// Charges Breakdown Section
const breakdownY = doc.lastAutoTable.finalY + 10;
doc.setFontSize(10);
doc.setTextColor(0, 0, 0);
doc.setFont("Times", "normal"); // Use Times New Roman

doc.text("Charges Breakdown:", 10, breakdownY);

let lastBreakdownY = breakdownY + 5; // Track the last Y position used in the breakdown

if (visibiliyCalculationDetails) {
  const lines = visibiliyCalculationDetails.split("\n"); // Split details into lines
  console.log("Lines for Charges Breakdown:", lines); // Log each line

  lines.forEach((line, index) => {
    const lineY = lastBreakdownY + index * 5; // Add each line with spacing
    doc.setFont("Times", "normal"); // Use Times New Roman

    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.text(line.trim(), 10, lineY);
    lastBreakdownY = lineY; // Update the last Y position
  });
} else {
  console.warn("No visibility calculation details available.");

  lastBreakdownY += 5;
  doc.setFontSize(8);
doc.setTextColor(0, 0, 0);
doc.setFont("Times", "normal"); // Use Times New Roman

  doc.text("No visibility calculation details available.", 10, lastBreakdownY);
}

 // Adjust footerY to start after the last breakdown line
 const footerY = lastBreakdownY + 10;

 // Footer Section
 doc.setFontSize(10);
 doc.setTextColor(0, 0, 0);
 doc.text("Bank Details:", 10, footerY);
 doc.text(
   `Bank Name: HDFC Bank
Account Name: OGCS Private Limited
Account Number: 50200084105798
IFSC Code: HDFC0000256
Branch: New Panvel`,
   10,
   footerY + 5
 );

 doc.setFontSize(10);
 doc.text("Thank you for connecting with BuildPro OGCS!", 105, footerY + 30, {
   align: "center",
 });
 doc.text(
   "If you have any questions or need assistance, please contact our support team.",
   105,
   footerY + 40,
   { align: "center" }
 );

  // Save PDF
  doc.save("Proforma_Invoice.pdf");
};


export default generateInvoice;





















// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import dayjs from "dayjs";
// import logo from "../Images/buillogo6.png";
// import anotherLogo from "../Images/OGGS_Logo.png";

// export const generateInvoice = (
//   sellerdetails,
//   visibilityPrice,
//   powerPackPrice,
//   depositAmount,
//   products,
//   invoiceId,
//   visibilityLevel,
//   hsnCode,
//   visibiliyCalculationDetails ,// Pass detailed breakdown
//   saleMode

// ) => {

//   console.log("Visibility Calculation Details in generateInvoice:", visibiliyCalculationDetails);

//   const doc = new jsPDF();

//   const formattedDate = dayjs().format("DD MMMM YYYY");
//   const subTotal = visibilityPrice + powerPackPrice + depositAmount;

// // ✅ GST should only apply to visibility & power pack charges for OGCS sales
// const gstAmount = saleMode === "Sale By Seller" ? subTotal * 0.18 : (visibilityPrice + powerPackPrice) * 0.18;

// // ✅ Final Total Amount Calculation
// const totalAmount = saleMode === "Sale By OGCS" 
//   ? visibilityPrice + powerPackPrice + gstAmount + depositAmount  // 🟢 No GST on deposit
//   : subTotal + gstAmount;  // 🔵 Sale By Seller includes GST on everything

//   // const subTotal = visibilityPrice + powerPackPrice + depositAmount;
//   // const gstAmount = saleMode === "Sale By Seller" ? subTotal * 0.18 : (visibilityPrice + powerPackPrice) * 0.18;
//   // const gstAmount = subTotal * 0.18;
//   // const totalAmount = subTotal + gstAmount;

//   // Add border
//   doc.setLineWidth(0.5);
//   doc.rect(5, 5, 200, 287);

//   // Header Section
//   if (anotherLogo) {
//     const anotherImage = new Image();
//     anotherImage.src = anotherLogo;
//     doc.addImage(anotherImage, "PNG", 10, 10, 40, 20);
//   }
//   if (logo) {
//     const image = new Image();
//     image.src = logo;
//     doc.addImage(image, "PNG", 160, 10, 40, 20);
//   }
//   doc.setFontSize(10);
//   doc.setTextColor(0, 0, 0);
//   doc.text("PERFORMA INVOICE", 105, 20, { align: "center" });
//   doc.setFontSize(12);
//   doc.text(`Date: ${formattedDate}`, 10, 40);
//   doc.text(`Invoice ID: ${invoiceId}`, 10, 46);

//   // Company and Seller Details in the Same Row
//   const companyDetails = `OGCS private Limited, BuildPro OGCS
// Navin Panvel,
// Dist: Raigad, Pin Code: 410206
// Contact: +91 9967610135
// Email: support@buildproogcs.com
// GST: 27AAEC01131F1ZW`;

//   const sellerDetailsText = `Customer Details:
// ${sellerdetails.name}
// ${sellerdetails.address.street}
// ${sellerdetails.address.city}, ${sellerdetails.address.state}, ${sellerdetails.address.country} - ${sellerdetails.address.postalCode}
// Contact: ${sellerdetails.mobile}
// Email: ${sellerdetails.email}
// PAN: ${sellerdetails.pan}
// GST: ${sellerdetails.gstNumber}`;

//   doc.setFontSize(10);
//   doc.text(companyDetails, 10, 60);
//   doc.text(sellerDetailsText, 110, 60);

//   // Combined Table for Product Details and Charges Breakdown
//   const tableData = products.map((product) => [
//     product.productName,
//     `Rs ${product.productPrice}`,
//     product.maxquantity,
//     product.visibilityLevel,
//     product.hsncode, // Corrected field name
//     "-",
//   ]);

//   tableData.push(
//     ["Visibility Charges", `Rs ${visibilityPrice}`, "-", "-", "-", "-"],
//     ["PowerPack Charges", `Rs ${powerPackPrice}`, "-", "-", "-", "-"],
//     ["Deposit Charges", `Rs ${depositAmount}`, "-", "-", "-", "-"],
//     ["Subtotal", `Rs ${subTotal.toFixed(2)}`, "-", "-", "-", "-"],
//     ["GST (18%)", `Rs ${gstAmount.toFixed(2)}`, "-", "-", "-", "-"],
//     ["Total Amount", `Rs ${totalAmount.toFixed(2)}`, "-", "-", "-", "-"]
//   );

//   const tableHeaders = [
//     "Name",
//     "Amount (Rs)",
//     "Max Qty",
//     "Visibility Level",
//     "HSN Code", // Correct header name
//     "Remarks",
//   ];

//   doc.autoTable({
//     head: [tableHeaders],
//     body: tableData,
//     startY: 110,
//     theme: "grid",
//     margin: { left: 10 },
//     styles: { fontSize: 10, cellPadding: 2 },
//     headStyles: { fillColor: [41, 128, 185], textColor: [255, 255, 255] },
//     footStyles: { fillColor: [41, 128, 185], textColor: [255, 255, 255] },
//   });

  
// // Charges Breakdown Section
// const breakdownY = doc.lastAutoTable.finalY + 10;
// doc.setFontSize(10);
// doc.setTextColor(0, 0, 0);
// doc.setFont("Times", "normal"); // Use Times New Roman

// doc.text("Charges Breakdown:", 10, breakdownY);

// let lastBreakdownY = breakdownY + 5; // Track the last Y position used in the breakdown

// if (visibiliyCalculationDetails) {
//   const lines = visibiliyCalculationDetails.split("\n"); // Split details into lines
//   console.log("Lines for Charges Breakdown:", lines); // Log each line

//   lines.forEach((line, index) => {
//     const lineY = lastBreakdownY + index * 5; // Add each line with spacing
//     doc.setFont("Times", "normal"); // Use Times New Roman

//     doc.setFontSize(10);
//     doc.setTextColor(0, 0, 0);
//     doc.text(line.trim(), 10, lineY);
//     lastBreakdownY = lineY; // Update the last Y position
//   });
// } else {
//   console.warn("No visibility calculation details available.");

//   lastBreakdownY += 5;
//   doc.setFontSize(8);
// doc.setTextColor(0, 0, 0);
// doc.setFont("Times", "normal"); // Use Times New Roman

//   doc.text("No visibility calculation details available.", 10, lastBreakdownY);
// }

//  // Adjust footerY to start after the last breakdown line
//  const footerY = lastBreakdownY + 10;

//  // Footer Section
//  doc.setFontSize(10);
//  doc.setTextColor(0, 0, 0);
//  doc.text("Bank Details:", 10, footerY);
//  doc.text(
//    `Bank Name: HDFC Bank
// Account Name: OGCS Private Limited
// Account Number: 50200084105798
// IFSC Code: HDFC0000256
// Branch: New Panvel`,
//    10,
//    footerY + 5
//  );

//  doc.setFontSize(10);
//  doc.text("Thank you for connecting with BuildPro OGCS!", 105, footerY + 30, {
//    align: "center",
//  });
//  doc.text(
//    "If you have any questions or need assistance, please contact our support team.",
//    105,
//    footerY + 40,
//    { align: "center" }
//  );

//   // Save PDF
//   doc.save("Proforma_Invoice.pdf");
// };


// export default generateInvoice;
